import superagentPromisePlugin from 'superagent-promise-plugin'

import config from 'config'
import http_agent from './http_agent'
import loginSync from './login_sync'
import bindersSync from './binders_sync'
import userSync from './user_sync'
import unitedStatesSync from './united_states_sync'
import cartSync from './cart_sync'
import privateLibrarySync from './private_library_sync'
import previewSync from './preview_sync'
import foldersSync from './folders_sync'
import schoolSync from './school_sync'
import userAdvancedSettingsSync from './user_advanced_settings_sync'
import googlePickerSync from './google_picker_sync'
import onboardingSync from './onboarding_sync'
import onboardingActivitySync from './onboarding_activity_sync'
import adminOnboardingSync from './admin_onboarding_sync'
import mediaSearchSync from './media_search_sync'
import quizSync from './quiz_sync'
import matchingPairsCtSync from './matching_pairs_ct_sync'
import drawItSync from './draw_it_sync'
import slideSync from './slide_sync'
import pollSync from './poll_sync'
import oeqSync from './oeq_sync'
import desmosSync from './desmos_sync'
import iconSync from './icon_sync'
import errorSync from './error_sync'
import storefrontSync from './storefront_sync'
import myLibrarySync from './my_library_sync'
import storeSync from './store_sync'
import ltiSync from './lti_sync'
import studentSync from './student_sync'
import featureFlagsSync from './feature_flags_sync'
import dmStorageExperimentSync from './dm_storage_experiment_sync'
import themesSync from './themes_sync'
import gameSync from './game_sync'
import assetSync from './asset_sync'
import googleDriveSync from './google_drive_sync'
import slideExternalSync from './slide_external_sync'
import flocabularySync from './flocabulary_sync'
import customSlideSync from './custom_slide_sync'
import goalsSync from './goals_sync'
import quickLaunchSync from './quick_launch_sync'
import lessonSync from './lesson_sync'
import interactiveVideoSync from './interactive_video_sync'
import navigationMenuSync from './navigation_menu_sync'
import flipgridSync from './flipgrid_sync'
import questionSync from './question_sync'
import generalSync from './general_sync'
import onboardingGuideSync from './onboarding_guide_sync'

function fetchShareDataSync(entityUID, entityType, libraryID) {
	let url = config.services
	if (entityType === 'lesson') {
		url += 'presentation/shareData?entityUID=' + entityUID + '&libraryID=' + libraryID
	} else if (entityType === 'storefront') {
		url = config.api + 'storefront/' + entityUID + '/share_data'
	} else {
		url += 'bundle/shareData?entityUID=' + entityUID
	}
	return http_agent.get(url)
		.use(superagentPromisePlugin)
		.withCredentials()
		.then(function(res) {
			return JSON.parse(res.text)
		})
		.catch(function(err) {
			return err.response
		})
}

function sendFormSync(params) {

	return http_agent.post(config[params.url] + params.service)
		.type('form')
		.send(params.queryObject)
		.use(superagentPromisePlugin)
		.withCredentials()
		.then(function() {
			return 'Sent'
		})
		.catch(function() {
			return 'Something went wrong. Please try again later.'
		})
}

export {
	fetchShareDataSync,
	sendFormSync,
	loginSync,
	bindersSync,
	userSync,
	unitedStatesSync,
	cartSync,
	privateLibrarySync,
	previewSync,
	foldersSync,
	schoolSync,
	userAdvancedSettingsSync,
	adminOnboardingSync,
	googlePickerSync,
	onboardingSync,
	mediaSearchSync,
	quizSync,
	matchingPairsCtSync,
	drawItSync,
	slideSync,
	pollSync,
	oeqSync,
	desmosSync,
	iconSync,
	errorSync,
	storefrontSync,
	myLibrarySync,
	ltiSync,
	storeSync,
	studentSync,
	featureFlagsSync,
	dmStorageExperimentSync,
	themesSync,
	gameSync,
	assetSync,
	googleDriveSync,
	slideExternalSync,
	flocabularySync,
	customSlideSync,
	onboardingActivitySync,
	goalsSync,
	quickLaunchSync,
	lessonSync,
	interactiveVideoSync,
	navigationMenuSync,
	flipgridSync,
	questionSync,
	generalSync,
	onboardingGuideSync,
}
